var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "700" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c("custom-dialog", {
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _vm._v(" " + _vm._s("カメラ追加") + " "),
                _c("button", { attrs: { id: "dialog_exit" } }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/popup_close.png"),
                      id: "btn_img",
                    },
                    on: {
                      click: function ($event) {
                        _vm.dialog = false
                      },
                    },
                  }),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  "v-row",
                  { staticClass: "ma-0 pa-0", attrs: { justify: "center" } },
                  [
                    _c(
                      "v-col",
                      {
                        staticClass: "ma-0 pa-0",
                        attrs: { cols: "11", align: "left" },
                      },
                      [
                        _c("CameraTreeSelect", {
                          model: {
                            value: _vm.selectedCameras,
                            callback: function ($$v) {
                              _vm.selectedCameras = $$v
                            },
                            expression: "selectedCameras",
                          },
                        }),
                        _c(
                          "v-col",
                          {
                            staticClass: "ma-0 pa-0 mt-5 pb-2",
                            attrs: { cols: "12" },
                          },
                          [
                            _c(
                              "v-row",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: { align: "center", justify: "center" },
                              },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: {
                                      width: "8rem",
                                      height: "2rem",
                                      id: "grey_btn",
                                      elevation: "0",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.dialog = false
                                      },
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(_vm.t("cancel")) + " ")]
                                ),
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "ma-0 pa-0 ml-2",
                                    attrs: {
                                      width: "8rem",
                                      height: "2rem",
                                      id: "blue_btn",
                                      elevation: "0",
                                    },
                                    on: { click: _vm.confirmAdd },
                                  },
                                  [_vm._v(" " + _vm._s(_vm.t("add2")) + " ")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }